import { Button } from '@Sage/hoi-poi-ui';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import stylejs from '../../styles';
import '../style.scss';

export function ActivePlanFooter({ active, onClick, custom, clicked }) {
    let content = active ? (
        <Button className="contact-us btn-primary" style={stylejs.btnCustomActive}>
            <Literal literal={'label_active_plan'} />
        </Button>
    ) : (
        <Button
            className="contact-us btn-primary"
            style={custom ? stylejs.btnCustomBlue : stylejs.btnCustom}
            onClick={!clicked ? onClick : undefined}
        >
            <Literal literal={'label_contact_us'} />
        </Button>
    );
    return content;
}

export function SendedPlanFooter() {
    return (
        <Button className="notification-sended" style={stylejs.btnCustomSended}>
            <Literal literal={'label_sended'} />
        </Button>
    );
}
